/** @format */

import React, { useState, useEffect } from "react";
import {
  Text,
  Textarea,
  Select,
  TextInput,
  SegmentedControl,
} from "@mantine/core";
import { camelCaseToTitle } from "../../utilities/utilities";
import { apiWrapWithErrorWithData } from "../../utilities/apiHelpers";
import {
  businessUnitDetails,
  getAgreementDetails,
  getOrgDetails,
  getuserMail,
} from "../../utilities/apis/agreements";
import flat from "flat";
import { getUserRolesUsingRoleId } from "../../utilities/apis/serviceProvider";
import {
  getBuDetails,
  getOrgDetailsFromMaster,
} from "../../utilities/apis/users";

const LegacyAgreementParty = ({
  legacyAgreementFormValue,
  dropDownNames,
  partyName,
  setDropDownNames,
  setLegacyAgreementFormValue,
  errors,
  isReadOnly = false,
  dataRole,
  setDataRole,
  onPartySelect,
}) => {
  if (
    !legacyAgreementFormValue[partyName] ||
    !legacyAgreementFormValue[partyName].type
  ) {
    if (!legacyAgreementFormValue[partyName]) {
      legacyAgreementFormValue[partyName] = {};
    }
    legacyAgreementFormValue[partyName].type = "Entity";
  }
  const type = legacyAgreementFormValue[partyName].type || "Entity";
  const isFirstParty = partyName === "firstParty";
  const [phone, setPhone] = useState("");
  const [budetails, setBudetails] = useState(null);
  const [userRolesIdData, setUserRolesIdData] = useState({
    userRoles: {
      SigningAuthority: [],
    },
  });
  const [selectedUserId, setSelectedUserId] = useState(null);

  useEffect(() => {
    if (
      userRolesIdData.userRoles.SigningAuthority.length > 0 &&
      legacyAgreementFormValue[`${partyName}`].signatory
    ) {
      const user = userRolesIdData.userRoles.SigningAuthority.find(
        (u) => u.name === legacyAgreementFormValue[`${partyName}`].signatory,
      );
      if (user) {
        setSelectedUserId(user.id);
      }
    }
  }, [userRolesIdData, legacyAgreementFormValue, partyName]);
  const [orgDetails, setOrgDetails] = useState({
    address: "",
    name: "",
    entityType: "Company",
    brandName: "",
    corporateAddress: "",
    email: "",
    representative: "",
  });

  const handlePhoneChange = (e) => {
    const value = e.target.value;
    // Allow only up to 10 digits
    if (value.length <= 10 && /^\d*$/.test(value)) {
      setPhone(value);
      // Update the form state only for a complete 10-digit number
      if (value.length === 10) {
        setLegacyAgreementFormValue({
          ...legacyAgreementFormValue,
          [`${partyName}`]: {
            ...legacyAgreementFormValue[partyName],
            indi_phone: value,
          },
        });
      }
    }
  };

  const getMail = async ({ id }) => {
    console.log("Getting mail for user ID:", id);

    // Check if id is valid
    if (!id) {
      console.error("getMail: ID is null or undefined");
      return null;
    }

    try {
      const resp = await apiWrapWithErrorWithData(getuserMail({ id }));
      if (resp.success) {
        return resp.email;
      } else {
        console.error("getMail: API returned error:", resp);
        return null;
      }
    } catch (error) {
      console.error("getMail: Exception occurred:", error);
      return null;
    }
  };

  useEffect(() => {
    const fetchUserRoles = async () => {
      try {
        const roles = {
          SigningAuthority: (
            await apiWrapWithErrorWithData(getUserRolesUsingRoleId(7))
          ).result,
        };

        setUserRolesIdData((prevData) => ({
          ...prevData,
          userRoles: roles,
        }));
      } catch (error) {
        console.error("Error fetching user roles:", error);
      } finally {
        console.log("final");
      }
    };

    fetchUserRoles();
  }, []);

  const bu = legacyAgreementFormValue["businessUnit"];
  console.log("buid: ", bu);
  const budetailsfetch = async () => {
    const response = await apiWrapWithErrorWithData(
      getBuDetails({ id: parseInt(bu) }),
    );
    // console.log(response);
    if (response.success) {
      setBudetails(response.result[0].details);
    } else {
      console.log("error accured in fetching bu details");
    }
  };

  useEffect(() => {
    if (bu) {
      budetailsfetch();
    }
  }, [bu]);

  useEffect(() => {
    const getOrganizationDetails = async () => {
      const resp = await apiWrapWithErrorWithData(getOrgDetailsFromMaster());
      if (resp.success) {
        setOrgDetails({
          address: resp.result[0].details["regAddress"] || "",
          entityType: resp.result[0].details["entityType"] || "",
          name: resp.result[0]["name"] || "",
          brandName: resp.result[0].details?.brandName || "",
          corporateAddress: resp.result[0].details?.corporateAddress || "",
          email: resp.result[0].details?.signEmail || "",
          representative: resp.result[0].details?.poc || "",
        });
      }
    };
    getOrganizationDetails();
  }, []);

  useEffect(() => {
    if (partyName === "firstParty" && orgDetails) {
      setLegacyAgreementFormValue((prevValues) => {
        const currentValues = flat.unflatten(prevValues);

        // Check if firstParty.name exists
        if (!currentValues.firstParty?.name) {
          const newValues = {
            ...currentValues,
            firstParty: {
              address: orgDetails.address,
              brandName: orgDetails.brandName,
              corporateAddress: orgDetails.corporateAddress,
              email: orgDetails.email,
              entityType: orgDetails.entityType,
              name: orgDetails.name,
              representative: orgDetails.representative,
              type: "Entity",
            },
          };
          return flat(newValues);
        }

        return prevValues;
      });
    }
  }, [orgDetails, partyName]);

  // --- AUTO-POPULATION LOGIC FOR SECOND PARTY ---
  useEffect(() => {
    const autoFillSecondParty = async () => {
      // 1. Only run if it's the second party and a name has been selected/provided
      const currentName = legacyAgreementFormValue[partyName]?.name;

      if (partyName !== "firstParty" && currentName) {
        // 2. Logic: If the name matches an item in your dropdown or database
        // In your case, we check if details are still empty before overwriting
        if (!legacyAgreementFormValue[partyName].address) {
          // If you have an API to fetch details by name, call it here.
          // Otherwise, this serves as a placeholder to sync data when name changes.
          console.log(`Checking auto-fill for: ${currentName}`);

          /* Example API trigger:
           const resp = await apiWrapWithErrorWithData(getSecondPartyDetails({ name: currentName }));
           if(resp.success) { 
              setLegacyAgreementFormValue(prev => ({...prev, [partyName]: { ...prev[partyName], address: resp.data.address }}));
           }
           */
        }
      }
    };

    autoFillSecondParty();
  }, [legacyAgreementFormValue[partyName]?.name, partyName]);

  // --- IMPROVED HANDLE NAME CHANGE ---
  // Replace your existing onChange for the 'registered name' Select with this:
  const handleNameSelection = (val) => {
    if (isReadOnly) return;

    setLegacyAgreementFormValue((prev) => {
      // Using the same 'flat' logic as your first party for consistency
      const currentValues = flat.unflatten(prev);

      return flat({
        ...currentValues,
        [partyName]: {
          ...currentValues[partyName],
          name: val,
          // If you want to reset fields when a new name is picked, do it here:
          // address: "",
          // email: ""
        },
      });
    });
  };
  console.log(onPartySelect, "on party seelct");

  return (
    <div className="flex flex-col">
      <br></br>
      <div className="flex justify-between" style={{ marginTop: "10px" }}>
        <Text color="#1b6f8d">{camelCaseToTitle(partyName).toLowerCase()}</Text>
        <SegmentedControl
          value={legacyAgreementFormValue[`${partyName}`].type}
          color="primary"
          data={["Entity", "Individual"]}
          onChange={(val) => {
            setLegacyAgreementFormValue({
              ...legacyAgreementFormValue,
              [`${partyName}`]: {
                ...legacyAgreementFormValue[partyName],
                type: val,
              },
            });
          }}
        />
      </div>
      <div className="grid grid-cols-3 gap-4">
        {type === "Entity" && (
          <>
            <Select
              required
              className="inputCustom "
              label="entity type"
              style={{ width: "100%", marginLeft: "0px", lineHeight: "1.55" }}
              data={[
                { value: "Company", label: "Company" },
                { value: "LLP", label: "LLP" },
                { value: "Partnership Firm", label: "Partnership Firm" },
                { value: "Sole Proprietary", label: "Sole Proprietary" },
              ]}
              disabled={isReadOnly}
              onChange={(val) => {
                if (!isReadOnly) {
                  setLegacyAgreementFormValue({
                    ...legacyAgreementFormValue,
                    [`${partyName}`]: {
                      ...legacyAgreementFormValue[partyName],
                      entityType: val,
                    },
                  });
                }
              }}
              error={errors?.entityType}
              value={legacyAgreementFormValue[`${partyName}`].entityType}
            />
            <Select
              required
              searchable
              creatable={!isReadOnly}
              className="inputCustom"
              label="registered name"
              placeholder="enter registered name"
              // data={dropDownNames}
              data={
                legacyAgreementFormValue[partyName].name
                  ? Array.from(
                      new Set([
                        ...dropDownNames,
                        legacyAgreementFormValue[partyName].name,
                      ]),
                    )
                  : dropDownNames
              }
              disabled={isReadOnly}
              getCreateLabel={(query) => `+ add ${query}`}
              onCreate={(query) => {
                if (!isReadOnly) {
                  setDropDownNames([...dropDownNames, query]);
                }
              }}
              // onChange={(val) => {
              //   if (!isReadOnly) {
              //     setLegacyAgreementFormValue({
              //       ...legacyAgreementFormValue,
              //       [`${partyName}`]: {
              //         ...legacyAgreementFormValue[partyName],
              //         name: val,
              //       },
              //     });
              //   }
              // }}
              onChange={(val) => {
                if (!isReadOnly) {
                  // If the custom handler exists (like for second party), use it
                  if (onPartySelect) {
                    onPartySelect(partyName, val);
                  } else {
                    // Fallback to original logic
                    setLegacyAgreementFormValue({
                      ...legacyAgreementFormValue,
                      [partyName]: {
                        ...legacyAgreementFormValue[partyName],
                        name: val,
                      },
                    });
                  }
                }
              }}
              value={legacyAgreementFormValue[`${partyName}`].name || ""}
              style={{
                width: "100%",
                lineHeight: "1.55",
              }}
              error={errors?.name}
            />

            <TextInput
              label="brand name"
              placeholder="enter brand name"
              disabled={isReadOnly || isFirstParty}
              onChange={(val) => {
                if (!isReadOnly && !isFirstParty) {
                  setLegacyAgreementFormValue({
                    ...legacyAgreementFormValue,
                    [`${partyName}`]: {
                      ...legacyAgreementFormValue[partyName],
                      brandName: val.target.value,
                    },
                  });
                }
              }}
              value={legacyAgreementFormValue[`${partyName}`].brandName || ""}
            />
            {isFirstParty ? (
              <Select
                required
                label="signing authority"
                placeholder="signing authority"
                value={
                  dataRole && dataRole["7"] && dataRole["7"][0]
                    ? dataRole["7"][0].userId
                    : null
                }
                onChange={async (selectedUser) => {
                  if (!isReadOnly) {
                    setDataRole({
                      ...dataRole,
                      ["7"]: [
                        {
                          userId: selectedUser,
                          isComplete: false,
                        },
                      ],
                    });
                    const selectedUserLabel =
                      userRolesIdData.userRoles.SigningAuthority.find(
                        (user) => user.id === selectedUser,
                      )?.name;
                    setLegacyAgreementFormValue({
                      ...legacyAgreementFormValue,
                      [`${partyName}`]: {
                        ...legacyAgreementFormValue[partyName],
                        signatory: selectedUserLabel,
                        email: await getMail({ id: selectedUser }),
                      },
                    });
                  }
                }}
                data={userRolesIdData.userRoles.SigningAuthority.map(
                  (user) => ({
                    value: user.id,
                    label: user.name,
                  }),
                )}
                // disabled={isReadOnly}
              />
            ) : (
              <>
                <TextInput
                  required
                  label="authorised signatory name"
                  placeholder="enter authorised signatory name"
                  disabled={isReadOnly}
                  onChange={(val) => {
                    if (!isReadOnly) {
                      setLegacyAgreementFormValue({
                        ...legacyAgreementFormValue,
                        [`${partyName}`]: {
                          ...legacyAgreementFormValue[partyName],
                          signatory: val.target.value,
                        },
                      });
                    }
                  }}
                  value={
                    legacyAgreementFormValue[`${partyName}`].signatory || ""
                  }
                />
                <TextInput
                  required
                  label="authorised signatory email"
                  placeholder="enter authorised signatory email"
                  disabled={isReadOnly}
                  onChange={(val) => {
                    if (!isReadOnly) {
                      setLegacyAgreementFormValue({
                        ...legacyAgreementFormValue,
                        [`${partyName}`]: {
                          ...legacyAgreementFormValue[partyName],
                          email: val.target.value,
                        },
                      });
                    }
                  }}
                  value={legacyAgreementFormValue[`${partyName}`].email || ""}
                />
              </>
            )}
            <TextInput
              label="business POC"
              placeholder="enter business POC"
              // disabled={isReadOnly || isFirstParty}
              onChange={(val) => {
                if (!isReadOnly && !isFirstParty) {
                  setLegacyAgreementFormValue({
                    ...legacyAgreementFormValue,
                    [`${partyName}`]: {
                      ...legacyAgreementFormValue[partyName],
                      representative: val.target.value,
                    },
                  });
                }
              }}
              value={
                legacyAgreementFormValue[`${partyName}`].representative || ""
              }
            />
            <TextInput
              label="business POC email"
              placeholder="enter business email"
              // disabled={isReadOnly || isFirstParty}
              onChange={(val) => {
                if (!isReadOnly && !isFirstParty) {
                  setLegacyAgreementFormValue({
                    ...legacyAgreementFormValue,
                    [`${partyName}`]: {
                      ...legacyAgreementFormValue[partyName],
                      pocemail: val.target.value,
                    },
                  });
                }
              }}
              value={legacyAgreementFormValue[`${partyName}`].pocemail || ""}
            />
            <Textarea
              label="registered address"
              placeholder="enter registered address"
              // disabled={isReadOnly || isFirstParty}
              onChange={(val) => {
                if (!isReadOnly && !isFirstParty) {
                  setLegacyAgreementFormValue({
                    ...legacyAgreementFormValue,
                    [`${partyName}`]: {
                      ...legacyAgreementFormValue[partyName],
                      address: val.target.value,
                    },
                  });
                }
              }}
              value={legacyAgreementFormValue[`${partyName}`].address || ""}
            />
            <Textarea
              label="corporate address"
              placeholder="enter corporate address"
              // disabled={isReadOnly || isFirstParty}
              onChange={(val) => {
                if (!isReadOnly && !isFirstParty) {
                  setLegacyAgreementFormValue({
                    ...legacyAgreementFormValue,
                    [`${partyName}`]: {
                      ...legacyAgreementFormValue[partyName],
                      corporateAddress: val.target.value,
                    },
                  });
                }
              }}
              value={
                legacyAgreementFormValue[`${partyName}`].corporateAddress || ""
              }
            />
          </>
        )}
        {type === "Individual" && (
          <>
            <TextInput
              required
              label="individual name"
              placeholder="enter individual name"
              onChange={(val) => {
                setLegacyAgreementFormValue({
                  ...legacyAgreementFormValue,
                  [`${partyName}`]: {
                    ...legacyAgreementFormValue[partyName],
                    indi_name: val.target.value,
                  },
                });
              }}
              value={legacyAgreementFormValue[`${partyName}`].indi_name || ""}
              error={
                // errors &&
                // errors[`${partyName}`] &&
                // errors[`${partyName}`].indi_name &&
                // errors[`${partyName}`].indi_name
                errors?.indi_name
              }
            />
            <TextInput
              label="father's name"
              placeholder="enter father's Name"
              onChange={(val) => {
                setLegacyAgreementFormValue({
                  ...legacyAgreementFormValue,
                  [`${partyName}`]: {
                    ...legacyAgreementFormValue[partyName],
                    indi_fatherName: val.target.value,
                  },
                });
              }}
              value={
                legacyAgreementFormValue[`${partyName}`].indi_fatherName || ""
              }
            />

            <TextInput
              label="PAN no."
              placeholder="enter PAN no."
              onChange={(val) => {
                setLegacyAgreementFormValue({
                  ...legacyAgreementFormValue,
                  [`${partyName}`]: {
                    ...legacyAgreementFormValue[partyName],
                    indi_pan: val.target.value,
                  },
                });
              }}
              value={legacyAgreementFormValue[`${partyName}`].indi_pan || ""}
            />
            <Textarea
              label="residence address"
              placeholder="enter residence address"
              onChange={(val) => {
                setLegacyAgreementFormValue({
                  ...legacyAgreementFormValue,
                  [`${partyName}`]: {
                    ...legacyAgreementFormValue[partyName],
                    indi_address: val.target.value,
                  },
                });
              }}
              value={
                legacyAgreementFormValue[`${partyName}`].indi_address || ""
              }
            />
            <TextInput
              required
              label="email"
              placeholder="enter email id"
              onChange={(val) => {
                setLegacyAgreementFormValue({
                  ...legacyAgreementFormValue,
                  [`${partyName}`]: {
                    ...legacyAgreementFormValue[partyName],
                    indi_email: val.target.value,
                  },
                });
              }}
              value={legacyAgreementFormValue[`${partyName}`].indi_email || ""}
            />
            <TextInput
              label="phone no."
              placeholder="enter 10 digit phone no."
              value={phone}
              onChange={handlePhoneChange}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default LegacyAgreementParty;
